/* eslint-disable react-hooks/rules-of-hooks */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import { fetchFlatData } from './fetchFlatData';
import { IApplicationContext } from '../../types/applicationContext';
import { selectSource, selectFlatFormValues, selectFormFields } from '../../selectors';
import { useGetTrackAddMyHomeObject } from '../../hooks';
import { setErrorMessage, setRedirectUrl } from 'shared/mf-my-home/slices';
import { EMyHomeEstimationTargets } from 'shared/mf-my-home/types/estimationTarget';

export const submitFlatData = createAsyncThunk<void, undefined, IThunkApi>(
  'form/submitFlatData',
  async (_, _thunkApi) => {
    const { extra, getState, dispatch } = _thunkApi;
    const state = getState();

    const source = selectSource(state);
    const filters = selectFormFields(state);

    const { houseId, area, roomsCount, flatNumber, isNeedChatSubscribe } = selectFlatFormValues(state);

    const trackMyHomeAddObjectSuccess = useGetTrackAddMyHomeObject({
      estimationTarget: EMyHomeEstimationTargets.flat,
      filters,
      isSubmit: true,
    });

    const parameters = {
      houseId,
      area,
      roomsCount,
      flatNumber,
      source,
      isNeedChatSubscribe,
      isNeedPushSubscribe: false,
    };

    try {
      const res = await fetchFlatData(parameters, extra as IApplicationContext);

      trackMyHomeAddObjectSuccess();

      dispatch(setRedirectUrl(res));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    }
  },
);
